/**
 * NicLen.Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type DriverNoteType = 'Transport' | 'Sick' | 'Vacation' | 'Private' | 'School' | 'Free' | 'Cancelled';

export const DriverNoteType = {
    Transport: 'Transport' as DriverNoteType,
    Sick: 'Sick' as DriverNoteType,
    Vacation: 'Vacation' as DriverNoteType,
    Private: 'Private' as DriverNoteType,
    School: 'School' as DriverNoteType,
    Free: 'Free' as DriverNoteType,
    Cancelled: 'Cancelled' as DriverNoteType
};

